<script setup lang="ts">
import {ref, onMounted, onUnmounted} from 'vue';
import {checkForUpdate} from '../../services/version.service';

const showNotification = ref(false);
const latestVersion = ref('');
const currentVersion = ref('');

const checkVersion = async () => {
    const result = await checkForUpdate();

    if (result) {
        currentVersion.value = result.currentVersion;
        latestVersion.value = result.latestVersion;

        // Show notification only when there's an update, hide otherwise
        showNotification.value = result.hasUpdate;
    }
};

const reload = () => {
    window.location.reload();
};

const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
        checkVersion();
    }
};

onMounted(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    // Initial check after a short delay
    setTimeout(checkVersion, 1000);
});

onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
});
</script>
<template>
    <transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="translate-y-2 opacity-0"
        enter-to-class="translate-y-0 opacity-100"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="translate-y-0 opacity-100"
        leave-to-class="translate-y-2 opacity-0">
        <div
            v-if="showNotification"
            class="toast toast-end z-50">
            <div class="alert alert-success max-w-sm shadow-lg">
                <div class="flex-1">
                    <div class="text-left">
                        <h3 class="text-sm font-bold">{{ $t('appUpdate.available') }}</h3>
                    </div>
                </div>
                <div class="flex-none gap-2">
                    <button
                        class="btn btn-sm btn-primary"
                        @click="reload">
                        {{ $t('appUpdate.update') }}
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<style scoped>
.toast {
    bottom: 1rem;
    right: 1rem;
}
</style>
